<template>
  <Requirements @nextClick="toNext" process="3" />
</template>

<script>
  export default {
    name: 'SolePropA',
    pRouter: 'ChooseMerchantType',
    data() {
      return {
      }
    },
    methods: {

    }
  }
</script>


<style lang="scss" scoped>

</style>
